import { z } from 'zod';

export const AssetCategorySchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, "form.validation.categoryNameRequired"),
    parentId: z.string().optional(),
    description: z.string().optional(),
    assetGroupId: z.preprocess(
        (val) => (val === '' || val === null || val === undefined ? undefined : String(val)),
        z.string().optional(),
    ),
    categoryOwners: z.array(z.string()).min(1, "form.validation.categoryOwnersRequired"),
    confidentialityValue: z.union([z.number(), z.string()]).refine(val => val !== undefined && val !== null && val !== '', { message: "form.validation.confidentialityValueRequired" }),
    integrityValue: z.union([z.number(), z.string()]).refine(val => val !== undefined && val !== null && val !== '', { message: "form.validation.integrityValueRequired" }),
    availabilityValue: z.union([z.number(), z.string()]).refine(val => val !== undefined && val !== null && val !== '', { message: "form.validation.availabilityValueRequired" }),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAssetCategorySchema = AssetCategorySchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateAssetCategorySchema = AssetCategorySchema.partial().extend({
    categoryOwners: z.array(z.string()).min(1, "form.validation.categoryOwnersRequired").optional(),
});
